import { Component, EventEmitter, Output, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-guide-modal',
  templateUrl: './guide-modal.component.html',
  styleUrls: ['./guide-modal.component.scss']
})
export class GuideModalComponent {
  @ViewChild('content') content!: TemplateRef<any>;
  @Output() closed = new EventEmitter<void>();
  faDownload = faDownload;

  constructor(private modalService: NgbModal) {}

  open() {
    if (this.content) {
      this.modalService.open(this.content, { centered: true, backdrop: 'static', size: 'lg', windowClass: 'guide-modal' });
    } else {
      console.error("No se encontró la referencia al template del modal.");
    }
  }

  close() {
    this.closed.emit();
  }
}
